// src/palettes/index.ts
import type { Palette } from '../core/types';
import { BUILTIN_PALETTES } from './builtin';

const CUSTOM_KEY = 'dither-web/custom-palettes';

export function loadCustomPalettes(): Palette[] {
  try {
    return JSON.parse(localStorage.getItem(CUSTOM_KEY) ?? '[]') as Palette[];
  } catch { return []; }
}

export function saveCustomPalettes(palettes: Palette[]): void {
  localStorage.setItem(CUSTOM_KEY, JSON.stringify(palettes));
}

export function allPalettes(): Palette[] {
  return [...BUILTIN_PALETTES, ...loadCustomPalettes()];
}
